<template>
    <div class="container" ref="noLineChart"></div>
</template>

<script>
import echarts from 'echarts';
import { noLineChart } from '@/runtime-components/config/chart.config';

export default {
    name: 'de-xa-noline',
    props: {
        data: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        let chartIns = {
            chart: null,
            option: []
        };
        return {
            getChart() {
                return chartIns;
            },
            option: noLineChart()
        }
    },
    mounted() {
        this.initChart();
    },
    destroyed(){
        this.destroyChart();
    },
    watch: {
        data(v) {
            let chart = this.getChart().chart;
            chart && (chart.setOption({
                series: [{
                    data: v
                }]
            }));
        }
    },
    methods: {
        initChart(){
            let chartIns = this.getChart();
            if (!chartIns.chart) {
                chartIns.chart = echarts.init(this.$refs.noLineChart);
                this.option.series[0].data = this.data;
                chartIns.chart.setOption(this.option);
                this.resizeChart = chartIns.chart.resize;
            }
        },
        destroyChart() {
            const chartIns = this.getChart();
            if(chartIns.chart){
               chartIns.chart.dispose();
               chartIns.chart = null;
            }
        }
    }
}
</script>

<style lang="less" scoped>
@import url('~@/runtime-components/assets/common.css');
</style>